import * as _ from "lodash";
import * as angular from "angular";
import { Team } from "../../../models/team.model";
import { TeamDataProvider } from "../../../data-provider/team.dp";
import { DialogUtils } from "../../../helper/dialog.helper";

let TeamDropdownComponent = {
    selector: "vcTeamDropdown",
    templateUrl:
        "/angular/components/team/dropdown/team-dropdown.component.html",
    bindings: {
        users: "=",
        ngModel: "=?",
    },
    controller: class TeamDropdownController {
        // * bindings for typescript compiler *
        public users: any;
        public ngModel?: any;
        // ************************************

        public teams = [];
        public tsearch = "";
        public deletedTeam: Team;
        //team object used for displaying the selected team name in the dropdown
        public team: Team;

        private readonly $scope: any;
        private readonly dialog: DialogUtils;
        private dataProvider: TeamDataProvider;

        constructor(
            $scope: any,
            TeamDataProvider: TeamDataProvider,
            ModelsUtils: any,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.dataProvider = TeamDataProvider;

            this.deletedTeam = ModelsUtils.team({
                tname: "Deleted Team",
                tstatus: "Deleted",
            });
        }

        $onInit() {
            this.dataProvider.getAllTeams().then((teams: Team[]) => {
                this.teams = teams;
                if (this.ngModel) {
                    this.teamFromTid(this.ngModel);
                }
            });
        }

        teamFromTid(tid: string | number): void {
            this.dataProvider.getTeam(tid).then(
                (teamResponse: Team) => (this.team = teamResponse),
                () => (this.team = _.cloneDeep(this.deletedTeam))
            );
        }

        selectTeam(team: Team): void {
            if (team) {
                this.team = team;
                this.ngModel = team.tid;
            } else {
                this.team = null;
                this.ngModel = null;
            }
        }

        openTeamModal(ev: any): void {
            this.dialog
                .show({
                    component: "vc-team-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    size: "large-plus",
                    ariaLabel: "Create Team",
                    locals: {
                        selectedTeam: {},
                        hideUsers: false,
                    },
                })
                .then(() => this.dataProvider.resetItems());
        }
    },
};

angular
    .module("team")
    .component(TeamDropdownComponent.selector, TeamDropdownComponent);
